import { __exports as optionsFromStrings } from "./index153.js";
var hasRequiredOptionsFromStrings;
function requireOptionsFromStrings() {
  if (hasRequiredOptionsFromStrings) return optionsFromStrings;
  hasRequiredOptionsFromStrings = 1;
  Object.defineProperty(optionsFromStrings, "__esModule", {
    value: true
  });
  optionsFromStrings.default = optionsFromStrings$1;
  function optionsFromStrings$1(options) {
    var intOptions = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];
    for (var intOption in intOptions) {
      if (intOptions.hasOwnProperty(intOption)) {
        intOption = intOptions[intOption];
        if (typeof options[intOption] === "string") {
          options[intOption] = parseInt(options[intOption], 10);
        }
      }
    }
    if (typeof options["displayValue"] === "string") {
      options["displayValue"] = options["displayValue"] != "false";
    }
    return options;
  }
  return optionsFromStrings;
}
export {
  requireOptionsFromStrings as __require
};
//# sourceMappingURL=index131.js.map
